// extracted by mini-css-extract-plugin
export var text = "_76-0";